const toStorage = (token) => {
  return {
    token_type: token.token_type,
    expires_at: Date.now() + token.expires_in * 1000,
    access_token: token.access_token,
    refresh_token: token.refresh_token,
  };
};

export {toStorage};